import { render } from "./PerformanceMarketingBanner.vue?vue&type=template&id=736c7e6e"
import script from "./PerformanceMarketingBanner.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__